import React from 'react';
import {FormGroup} from 'react-bootstrap';
import Select from 'react-select';
// import FontAwesome from 'react-fontawesome';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
// import SWTNewColorModal from '../../../view/workdoc/SWTNewColorModal';
// import WorkdocStore from '../../../stores/WorkdocStore';

class SelectWithIcon extends React.Component {

  constructor(...args) {
    super(...args);
    this.initial();
  }

  initial() {

  }

  onFormChange = (e) => {
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    let evalue = multi?e:e.value;
    this.props.onChange(evalue);
  };

  renderOption = (option) => {
    const options = this.props.schema.options || {};
    const {
      icon_base_url,
      icon_size,
      icon_ext,
    } = options;

    if (!icon_base_url) {
      return option.label;
    }

    return (
        <span><img
            alt=''
            src={`${icon_base_url}${option.value.toUpperCase()}-${icon_size}.${icon_ext}`}
        /> {option.label}</span>
    );
  };

  render() {
    const {
      store,
      formData,
      schema,
      disabled,
      readonly,
      uiSchema
    } = this.props;
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    const options = this.props.schema.options || {};
    
    return (
        <FormGroup>
          <Select
              multi={multi}
              removeSelected={multi}
              disabled={disabled}
              readOnly={readonly}
              placeholder={'โปรดระบุ'}
              clearable={false}
              value={formData}
              options={store.options[options.option_field]
                       || schema.enum.map((item) => ({label: item, value: item}))
                       || []}
              onChange={this.onFormChange}
              valueRenderer={this.renderOption}
              optionRenderer={this.renderOption}
          >
          </Select>

        </FormGroup>
    );
  }
};

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectWithIcon);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectWithIcon.js